import React from 'react';

const Home = () => {
    return (
        <div className="h-screen pb-14 bg-right bg-cover" style={{ backgroundImage: "url('bg.svg')" }}>
            {/*Nav*/}
            <div className="w-full container mx-auto p-6">
                <div className="w-full flex items-center justify-between">
                    <a className="flex items-center text-gray-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="/">
                        <img className="h-10 fill-current text-gray-600 pr-2" src="launch_image.svg" alt="logo"></img> Buku Ende HKBP
                    </a>
                    <div className="flex w-1/2 justify-end content-center">
                        <a className="inline-block text-indigo-300 no-underline hover:text-indigo-800 hover:text-underline text-center h-10 p-2 md:h-auto md:p-4" href="/support">
                        <h1 className="my-4 text-3xl md:text-5xl text-indigo-800 font-bold leading-tight text-center md:text-left">Support</h1>
                        </a>
                    </div>
                </div>
            </div>
            {/*Main*/}
            <div className="container px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center">
                {/*Left Col*/}
                <div className="flex flex-col w-full xl:w-2/5 justify-center lg:items-start overflow-y-hidden">
                    <h1 className="my-4 text-3xl md:text-5xl text-indigo-800 font-bold leading-tight text-center md:text-left slide-in-bottom-h1">Buku Ende HKBP Simple dan Modern</h1>
                    <p className="leading-normal text-base md:text-2xl mb-8 text-center md:text-left slide-in-bottom-subtitle">Cari pujian dengan cepat dan Puji nama Tuhan! Haleluya!</p>
                    <p className="text-indigo-400 font-bold pb-8 lg:pb-6 text-center md:text-left fade-in">Download sekarang:</p>
                    <div className="flex w-full justify-center md:justify-start pb-24 lg:pb-0 fade-in">
                        <a href='https://apps.apple.com/app/kidung-pasamuan-jawi/id6497061817'><img src="App Store.svg" className="h-12 pr-4 bounce-top-icons" alt="App Store Logo" /></a>
                        <a href='https://play.google.com/store/apps/details?id=com.dimasnath.kidungpasamuanjawi'><img src="Play Store.svg" className="h-12 bounce-top-icons" alt="Play Store Logo" /></a>
                    </div>
                </div>
                {/*Right Col*/}
                <div className="w-full xl:w-3/5 py-6 overflow-y-hidden">
                    <img className="w-5/6 mx-auto lg:mr-0 slide-in-bottom" src="devices.svg" alt="Devices Mockup" />
                </div>
                {/*Footer*/}
                <div className="w-full pt-16 pb-6 text-sm text-center md:text-left fade-in">
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/">&copy; Buku Ende HKBP App 2024</a>
                    <span className="mx-3 text-indigo-300">|</span>
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/privacy-policy">Privacy Policy</a>
                    <span className="mx-3 text-indigo-300">|</span>
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/support">Support</a>
                </div>
            </div>
        </div>
    );
}

export default Home;